module.exports = `
...on Error404 {
  message {
    json
  }
}`;
